import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import { styled } from '@mui/system';
import {Grid, Box, Button} from '@material-ui/core';
import {Checkbox, FormControlLabel } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios'; 
import moment from 'moment';
import Comments from '../comments/Comments';
import InvoiceStatusMenu from './InvoiceStatusMenu';
import {API_URL} from '../utils/EnvVars';

const StyledTableCell = styled(TableCell)({
  padding: "3px 0px 3px 5px",
})
const StyledTableCellPdZero = styled(TableCell)({
  padding: 0,
})


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false); 
  
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [commentList, setCommentList] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  
  const [sgstChk, setSgstChk] = React.useState(true);
  const [igstChk, setIgstChk] = React.useState(false);
  const [discountChk, setDiscountChk] = React.useState(false);
  const [discountType, setDiscountType] = React.useState("%");
  const [unitOfMeasureChk, setUnitOfMeasureChk] = React.useState(false);
  
  const [accountName, setAccountName] = React.useState("");
  const [contactName, setContactName] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [billingAddress, setBillingAddress] = React.useState("");

  const [deliveryContactName, setDeliveryContactName] = React.useState("");
  const [deliveryEmail, setDeliveryEmail] = React.useState("");
  const [deliveryMobile, setDeliveryMobile] = React.useState("");
  const [deliveryPhone, setDeliveryPhone] = React.useState("");
  const [deliveryAddress, setDeliveryAddress] = React.useState("");

  ///const [status, setStatus] = React.useState("Draft");
  const [referenceNumber, setReferenceNumber] = React.useState("");
  const [receivedByAlias, setReceivedByAlias] = React.useState("");
  const [receivedMobile, setReceivedMobile] = React.useState("");
	const [receivingDate, setReceivingDate] = React.useState(moment(new Date()).format('YYYY-MM-DD'));
	const [expectedPaymentDate, setExpectedPaymentDate] = React.useState(moment(new Date()).format('YYYY-MM-DD'));
	const [invoiceDate, setInvoiceDate] = React.useState(moment(new Date()).format('YYYY-MM-DD'));
  const [discountOnTotal, setDiscountOnTotal] = React.useState("");
  const [customerNote, setCustomerNote] = React.useState("");
  const [grandTotal, setGrandTotal] = React.useState(0);

  const [pdfFileName, setPdfFileName] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));

  
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}
 
  React.useEffect(() => {	

    if(props.dataObj && props.dataObj.autoId && props.dataObj.autoId>0){

      if(props.dataObj.sgstOption===1){
        setSgstChk(true);
      }else{
        setSgstChk(false);
      }
      if(props.dataObj.igstOption===1){
        setIgstChk(true);
      }else{
        setIgstChk(false);
      }
      if(props.dataObj.discountOption===1){
        setDiscountChk(true);
      }else{
        setDiscountChk(false);
      }
      if(props.dataObj.uomOption===1){
        setUnitOfMeasureChk(true);
      }else{
        setUnitOfMeasureChk(false);
      }      
      setDiscountType(props.dataObj.discountType);
      setAccountName(props.dataObj.accountName);
      setContactName(props.dataObj.contactName);
      setMobile(props.dataObj.mobile);
      setEmail(props.dataObj.email);
      setBillingAddress(props.dataObj.billingAddress);
    
      setDeliveryContactName(props.dataObj.deliveryContactName);
      setDeliveryEmail(props.dataObj.deliveryEmail);
      setDeliveryMobile(props.dataObj.deliveryMobile);
      setDeliveryPhone(props.dataObj.deliveryPhone);
      setDeliveryAddress(props.dataObj.deliveryAddress);
    
      ///setStatus(props.dataObj.status);
      setReferenceNumber(props.dataObj.referenceNumber);
      setReceivedByAlias(props.dataObj.receivedByAlias);
      setReceivedMobile(props.dataObj.receivedMobile);
      setDiscountOnTotal(props.dataObj.discountOnTotal);
      setCustomerNote(props.dataObj.customerNote);
      setGrandTotal(props.dataObj.grandTotalAmount);

      setPdfFileName(props.dataObj.pdfFile);

      if(props.dataObj.invoiceDate){
        let dateArr = props.dataObj.invoiceDate.split("-");
        setInvoiceDate(moment(new Date(dateArr[2]+"-"+dateArr[1]+"-"+dateArr[0])).format('YYYY-MM-DD'))
      }
      if(props.dataObj.receivedDate){
        let dateArr = props.dataObj.receivedDate.split("-");
        setReceivingDate(moment(new Date(dateArr[2]+"-"+dateArr[1]+"-"+dateArr[0])).format('YYYY-MM-DD'))
      }
      if(props.dataObj.expectedPaymentDate){
        let dateArr = props.dataObj.expectedPaymentDate.split("-");
        setExpectedPaymentDate(moment(new Date(dateArr[2]+"-"+dateArr[1]+"-"+dateArr[0])).format('YYYY-MM-DD'))
      }
    
    }

//      setRows([]);
      if(props.userObj && open){
        getApiDataItems();
        getApiDataComments();
      }

	}, [props.dataObj, props.userObj,open]);
  

  async function getApiDataItems(){
		let axiosHeader = {
		  headers: {
			'Content-Type': 'multipart/mixed',
			'device': 'web',
			'registerId': props.userObj.registerId,
			'uid': props.userObj.loginId,
			'fullName': props.userObj.fullName,
			'token': props.userObj.token,
		  }
		};

    axios.get(API_URL+'/crm-list-invoices-items?invoiceId='+props.dataObj.autoId, axiosHeader)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){ 
        setRows(response.data.list);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        navigate('/invalidtoken');
        
      } 		 				
    }).catch((error) => {
      })
  }


  async function getApiDataComments(){ 
    let apiUrl=API_URL+'/crm-comments-cache?relatedTo=Invoice&relatedToId='+props.dataObj.autoId;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){  
          setCommentList(response.data.list);	
      }else if(response && response.data && response.data.responseTxt==="failed"){  
          setCommentList([]);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        navigate('/invalidtoken');

      }
    })
  }

  function createPDF(event){
    
		if(props.userObj){ 
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/form-data',
					'device': 'web',
					'registerId': props.userObj.registerId,
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
				}
			}; 
			const data = new FormData();
      data.append('id', props.dataObj.autoId);

      let alertMsg = 'Invoice PDF has been created.';
      if(event==='remove'){
        alertMsg = 'Invoice PDF has been removed.';
      }

			axios.post(API_URL+'/crm-update-invoice-pdf?event='+event, data, axiosHeader)
			.then((response) => {
        if(response.data.responseTxt==="success"){
          setPdfFileName(response.data.obj.title);
          setSeverityAlert("success");          
					setShowAlert(true);
					setAlertMessage(alertMsg);          	
					return false;

        }else if(response.data.responseTxt==="invalidtoken"){
            navigate('/invalidtoken');
  
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Something wrong");			
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}

  function comments(list) {
    setCommentList(list);
  }

  return (props.dataObj?
    <>
      <Dialog fullScreen style={{margin:5}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>{props.dataObj.invoiceNumber}</DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} style={{marginRight:15}} >
                  
                  <Box mb={1} >
						        <Grid container spacing={2}>
                    
                          <Grid item md={3} xs={12} >
                            <div>
                              Customer Billing To: 
                            </div>
                              {accountName}<br/>
                              {contactName}<br/>
                              {mobile}<br/>
                              {email}<br/>
                              {billingAddress}<br/>
                            </Grid>    

                            <Grid item md={3} xs={12} >
                            <div>
                              Delivery To: 
                            </div>
                              {deliveryContactName}<br/>
                              {deliveryMobile}<br/>
                              {deliveryPhone}<br/>
                              {deliveryEmail}<br/>
                              {deliveryAddress}<br/>
                            </Grid>

                            <Grid item md={3} xs={12} >                            
                            Invoice Date: {invoiceDate}<br/>
                            Expected Payment Date: {expectedPaymentDate}<br/>                            
                            Invoice Receiver Name: {receivedByAlias}<br/>
                            Invoice Receiver Mobile: {receivedMobile}<br/>
                            Receiving Date: {receivingDate}<br/>

                            </Grid>

                            <Grid item md={3} xs={12} >
                              <Grid container >
                                <Grid item xs={3}>
                                    Status
                                </Grid>
                                <Grid item xs={9} style={{marginTop: -3}}>
                                    <InvoiceStatusMenu userObj={props.userObj} dataObj={props.dataObj} title={props.dataObj.status} /> 
                                </Grid>
                              </Grid>
                              <Grid container >
                                <Grid item xs={12} >
                                    {(pdfFileName && pdfFileName.length>0)?
                                    <><a href={props.dataObj.fileUrl+'/'+pdfFileName} >{pdfFileName}</a> <i onClick={()=>{createPDF('remove')}} title="Remove PDF" className="fa fa-trash btncolor" style={{fontSize:15, marginLeft:2, cursor:'pointer', color: '#f78a74'}} /></>:
                                    <Button onClick={() => {createPDF('create')}} style={{textTransform:'none', maxHeight:25, width: 170}} size="small" variant="outlined" >Create PDF</Button> 
                                    }
                                </Grid>
                              </Grid>
                              <Grid container >
                                <Grid item xs={12} >
                                  Account Number: {props.dataObj.accountNumber}<br/>
                                  Reference Number: {referenceNumber}<br/>
                                </Grid>
                              </Grid>


                            </Grid>

                            <Grid item md={12} xs={12} >  
                              
                            
                              <Typography component={Stack} direction="row" alignItems="center">
                                  {sgstChk?<CheckBoxIcon color="primary" />:<CheckBoxOutlineBlankIcon />} SGST/CGST
                                  {igstChk?<CheckBoxIcon color="primary" />:<CheckBoxOutlineBlankIcon  />} IGST
                                  {discountChk?<CheckBoxIcon color="primary" />:<CheckBoxOutlineBlankIcon/>} Discount
                                  {unitOfMeasureChk?<CheckBoxIcon color="primary" />:<CheckBoxOutlineBlankIcon/>} Unit Of Measure
                              </Typography>
                             
                             {/* {rows.length} */}
                            <TableContainer component={Paper}>
                                  <Table sx={{ width: '100%', minWidth: 1000 }} size="small" aria-label="simple table">
                                    <TableHead>
                                      <TableRow>
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >Item</StyledTableCell>            
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >Description</StyledTableCell> 
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >HSN/SAC</StyledTableCell>
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >Qty</StyledTableCell>
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >Unit Price</StyledTableCell>
                                        {unitOfMeasureChk?
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >UOM</StyledTableCell>
                                        :null}                                        
                                        {sgstChk?<>
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >SGST</StyledTableCell> 
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >CGST</StyledTableCell>
                                        </>:null}
                                        {igstChk?
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >IGST</StyledTableCell>
                                        :null}
                                        {discountChk?
                                          <StyledTableCellPdZero style={{paddingLeft:2, verticalAlign:'bottom'}}>
                                                <div style={{margin: 0, padding: 0}}>Discount</div>                                            
                                                <FormControlLabel
                                                    control={
                                                      <Checkbox sx={{'& .MuiSvgIcon-root': {fontSize: 15, marginRight:  -1, }, }} checked={discountType==='%'} disabled checkedIcon={<CheckCircleRoundedIcon />} icon={<CircleOutlinedIcon />} />
                                                    }
                                                    label="%"
                                                    sx={{marginRight:1}}
                                                />
                                                <FormControlLabel
                                                    control={
                                                      <Checkbox sx={{'& .MuiSvgIcon-root': {fontSize: 15, marginRight:  -1, }, }} checked={discountType==='flat'} disabled checkedIcon={<CheckCircleRoundedIcon />} icon={<CircleOutlinedIcon />} />
                                                    }
                                                    label="flat"
                                                />
                                          </StyledTableCellPdZero>
                                        :null}                                        
                                        <StyledTableCell style={{verticalAlign:'bottom'}} >Total</StyledTableCell> 
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {(rows && rows.length>0)?rows.map((row,index) => (
                                        <TableRow
                                          key={row.autoId}
                                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                          <StyledTableCell component="th" scope="row" >
                                              {row.itemName}
                                          </StyledTableCell>              
                                          <StyledTableCell component="th" scope="row" >
                                            {row.description}
                                          </StyledTableCell>
                                          <StyledTableCell style={{width: 60}}>
                                            {row.hsn}
                                          </StyledTableCell>
                                          <StyledTableCell style={{width: 60}}>
                                            {row.qty}
                                          </StyledTableCell>
                                          <StyledTableCell style={{width: 100}}>
                                          &#8377; {row.unitPrice}
                                          </StyledTableCell>
                                          {unitOfMeasureChk?
                                          <StyledTableCell style={{width: 60}}>
                                            {row.uom}
                                          </StyledTableCell>
                                          :null}
                                          {sgstChk?<>
                                          <StyledTableCell style={{width: 60}} >
                                            {row.sgst}%
                                          </StyledTableCell>
                                          <StyledTableCell style={{width: 60}} >
                                            {row.cgst}%
                                          </StyledTableCell>
                                          </>:null}
                                          {igstChk?
                                          <StyledTableCell style={{width: 60}} >
                                            {row.igst}%
                                          </StyledTableCell>
                                          :null}
                                          {discountChk?
                                          <StyledTableCell style={{width: 81}} >
                                            {row.discount}
                                          </StyledTableCell>
                                          :null}
                                          <StyledTableCell style={{width: 100}}>
                                          &#8377; {row.total}
                                          </StyledTableCell>
                                        </TableRow>
                                      )):null}

                                        <TableRow
                                          sx={{ '&:last-child td, &:last-child th': { border: 0, paddingTop: 2, paddingBottom: 1 } }}
                                        >
                                          <StyledTableCell component="th" scope="row" colSpan={5} style={{verticalAlign:'top'}} >
                                              Customer Note: <br/>
                                              {customerNote}
                                          </StyledTableCell> 
                                          {unitOfMeasureChk?
                                          <StyledTableCell style={{width: 60}}>&nbsp;</StyledTableCell>
                                          :null}
                                          {sgstChk?<>
                                          <StyledTableCell style={{width: 60}} >&nbsp;</StyledTableCell>
                                          </>:null}
                                          
                                          {discountChk?
                                          <StyledTableCell colSpan={2} style={{width: 81, verticalAlign:'top'}} >
                                              <TextField disabled size='small' label="Discount Amount on Total" value={discountOnTotal} variant="outlined" fullWidth InputLabelProps={{shrink: true, }} />
                                          </StyledTableCell>
                                          :<StyledTableCell style={{width: 81, verticalAlign:'top'}} ></StyledTableCell>}
                                          <StyledTableCell style={{width: 100, verticalAlign:'top', paddingRight: 5}}>
                                              <TextField disabled label="Grand Total" value={grandTotal} size='small' fullWidth variant="outlined" InputLabelProps={{shrink: true, }} />
                                          </StyledTableCell>
                                        </TableRow>


                                    </TableBody>
                                  </Table>
                                </TableContainer>


                            </Grid>

                           

                    </Grid>
                  </Box>        

                  <Box style={{ width: '100%', typography: 'body1', marginTop: 10 }}>

                      <Comments relatedTo={'Invoice'} relatedToId={props.dataObj.autoId} showToCustomer={false} rows={commentList} userObj={props.userObj} comments={comments} /> 

                  </Box>               

            </Grid>
          </DialogContent>
      </Dialog>
      
      <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

        
    </>
  :null);

});

export default CustomizedDialogs;